import { EventEmitter } from 'events';
import { ChangeEvent, RequestEvent, TranscriptionActionTypes, TranscriptionEvent } from './utils';
import { TranscribingActionTypes } from '../common/enums/transcribingEnums';
import { TranscribingState } from '../pages';
import Dispatcher from '../dispatcher';
import { TranscribingEntryPoints } from '../../AppConstants';

export const INDEX_NONE = -1;

const defaultState: TranscribingState = {
  editingIndex: INDEX_NONE,
  isAudioPlaying: false,
  focusedIndex: 0,
  highlightedIndex: INDEX_NONE,
  sourceFile: null,
  transcriptionData: [],
  transcriptionManager: null,
  isTeachingUIClosed: true,
  showStartOverConfirmDialog: false,
  isAudioPlayerZoomedOutOfScreen: false,
  isDialogZoomedOutOfScreen: false,
  transcribingEntryPoints: TranscribingEntryPoints.DEFAULT,
  isAddToDocumentInProgress: false,
};

class TranscribingStore extends EventEmitter {
  private state: TranscribingState;

  constructor() {
    super();

    this.state = this.getInitialState();
  }

  private getInitialState = (): TranscribingState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, defaultState);
  }

  public getState = (): TranscribingState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, this.state);
  }

  public handleActions = (action: Event): void => {
    switch (action.type) {
      case TranscribingActionTypes.SetSourceFileAction:
        this.state.sourceFile = (<TranscriptionEvent>action).payload.sourceFile;
        this.state.isTeachingUIClosed = !((<TranscriptionEvent>action).payload.isNewTranscript);
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetEditingIndexAction:
        this.state.editingIndex = (<TranscriptionEvent>action).payload !== undefined ? (<TranscriptionEvent>action).payload : INDEX_NONE;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetFocusedIndexAction:
          this.state.focusedIndex = (<TranscriptionEvent>action).payload !== undefined ? (<TranscriptionEvent>action).payload : 0;
          this.emit(ChangeEvent.Change);
          break;
      case TranscribingActionTypes.SetAudioPlayingFlag:
        this.state.isAudioPlaying = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetTeachingUIClosedFlag:
        this.state.isTeachingUIClosed = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetShowStartOverConfirmDialog:
        this.state.showStartOverConfirmDialog = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetHighlightedIndexAction:
        this.state.highlightedIndex = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetTranscriptionDataAction:
        this.state.transcriptionData = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetTranscriptionManager:
        this.state.transcriptionManager = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.RevertStateAction:
        this.state = this.getInitialState();
        this.emit(ChangeEvent.Change);
        break;
      case TranscriptionActionTypes.ShareCurrentTranscriptionState:
        this.emit(RequestEvent.CurrentTranscriptionState);
        break;
      case TranscribingActionTypes.SetTranscriptionEntryPoints:
        this.state.transcribingEntryPoints = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case TranscribingActionTypes.SetAddToDocumentInProgressStatus:
        this.state.isAddToDocumentInProgress = (<TranscriptionEvent>action).payload;
        this.emit(ChangeEvent.Change);
        break;
    }
  }
}

const transcribingStore = new TranscribingStore;
Dispatcher.register(transcribingStore.handleActions);
export default transcribingStore;
